import { trackClientEvent } from 'analytics/analytics'

export type ExperiencesPassportSurface = 'search_tile' | 'offer_page' | 'my_escapes'
export type ExperiencesPassportAction = 'impression' | 'list_opened' | 'item_opened'

export function trackExperiencesPassportEvent(
  action: ExperiencesPassportAction,
  surface: ExperiencesPassportSurface,
): void {
  trackClientEvent({
    subject: 'experiences_passport',
    action,
    category: surface,
    type: action === 'impression' ? 'nonInteraction' : 'interaction',
  })
}
